module.exports = __webpack_public_path__ + "media/icons/check-orange-28e53313.svg";